import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-night-700 last:border-0" data-id="element-14">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-4 flex items-center justify-between text-left focus:outline-none group" data-id="element-15">
        <span className="font-medium text-starlight-100 group-hover:text-amber-400 transition-colors" data-id="element-16">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-lavender-400 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-17" />
      </button>
      <AnimatePresence data-id="element-18">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-19">
            <p className="pb-4 text-starlight-200/70 text-sm leading-relaxed" data-id="element-20">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}